module.exports = __webpack_public_path__ + "img/iomico-map-pin.21cd1e1a.svg";